import type { TourTargetRect } from './tourTypes';

import styles from './TourSpotlight.module.css';

interface TourSpotlightProps {
  rect: TourTargetRect | null;
}

const SPOTLIGHT_PADDING = 6;

export function TourSpotlight({ rect }: TourSpotlightProps) {
  if (!rect) {
    return null;
  }

  return (
    <div aria-hidden="true" className={styles.layer}>
      <div
        className={styles.cutout}
        style={{
          height: `${Math.max(rect.height + SPOTLIGHT_PADDING * 2, 0)}px`,
          left: `${rect.left - SPOTLIGHT_PADDING}px`,
          top: `${rect.top - SPOTLIGHT_PADDING}px`,
          width: `${Math.max(rect.width + SPOTLIGHT_PADDING * 2, 0)}px`,
        }}
      />
    </div>
  );
}
